import axios from "utils/axios";
import { routes } from "api/routes";

export const apiGetAllSectors = async () => {
  const { data } = await axios.get(routes.getAllSectors);
  return data;
};
